<template>
  <v-dialog
    v-model="vehicleCreateDialog_re"
    max-width="1200px"
    scrollable
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeVehicleCreateDialog"
  >
    <!-- <template v-slot:activator="{ on }">
      <div v-on="on">
        <slot />
      </div>
    </template> -->
    <v-card>
      <!-- <v-toolbar dark color="primary" max-height="60">
        {{ $i18n.t("Add Vehicle") }}
      </v-toolbar> -->
      <v-toolbar dark color="primary" max-height="60">
        {{ $i18n.t("Add Vehicle") }}
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeVehicleCreateDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form id="form">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{ $i18n.t("Add New Vehicle") }}
            </div>
          </template>
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" md="3" v-if="!vehicleForm.marketVeh">
                <z-vendor-select
                  v-model="vehicleForm.supplier_id"
                  :title="$i18n.t('Supplier') + '*'"
                  withSelf
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="vehicleForm.marketVeh"
                  :label="$i18n.t('Market Vehicle')"
                />
              </v-col>

              <!-- <v-col cols="12" md="3" v-if="vehicleForm.forAdhoc">
                <v-text-field
                  v-model="vehicleForm.supplierName"
                  :label="$i18n.t('Supplier Name') + '*'"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleForm.forAdhoc">
                <v-text-field
                  v-model="vehicleForm.supplierTaxId"
                  :label="$i18n.t('Tax Id') + '*'"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleForm.forAdhoc">
                <z-country-select
                  madatoryMark="true"
                  v-model="vehicleForm.supplierAddress.country"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleForm.forAdhoc">
                <z-city-select
                  madatoryMark="true"
                  v-model="vehicleForm.supplierAddress.city"
                  :country="vehicleForm.supplierAddress.country"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleForm.forAdhoc">
                <v-text-field
                  v-model="vehicleForm.supplierTaxId"
                  :label="$i18n.t('Address Line')"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleForm.forAdhoc">
                <v-text-field
                  v-model="vehicleForm.supplierContact.name"
                  :label="$i18n.t('Contact Person Name') + '*'"
                />
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleForm.forAdhoc">
                <v-row>
                  <v-col cols="12" md="4">
                    <z-country-select
                      preIcon="mdi-earth"
                      v-model="vehicleForm.supplierContact.countryCode"
                      :label="$i18n.t('Code') + '*'"
                      isd
                      hideName
                      hideFlag
                    />
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field
                      :label="$i18n.t('Phone') + '*'"
                      name="login"
                      prepend-icon="person"
                      type="text"
                      v-model="vehicleForm.supplierContact.phone"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3" v-if="vehicleForm.forAdhoc">
                <v-text-field
                  v-model="vehicleForm.supplierContact.email"
                  :label="$i18n.t('Contact Person Email') + '*'"
                />
              </v-col> -->
              <!-- <v-col cols="12" md="3">
                <v-checkbox
                  v-model="vehicleForm.forAdhoc"
                  :label="$i18n.t('Adhoc')"
                />
              </v-col> -->
            </v-row>
            <v-row>
              {{ $i18n.t("Vehicle Detail") }}
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-text-field
                  v-model="vehicleForm.regNo"
                  :label="$i18n.t('Vehicle Reg. No') + '*'"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <z-name-master-select
                  :hideAddNew="true"
                  :label="'Body Type *'"
                  v-model="vehicleForm.bodyType"
                  :type="10"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <z-vehicle-type-select
                  :bodyType="vehicleForm.bodyType"
                  categories="true"
                  v-model="vehicleForm.truckType"
                  @truckTypeName="setTruckTypeName"
                  :label="'Truck Type *'"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <z-vehicle-type-select
                  :label="'Vehicle Type'"
                  v-model="vehicleForm.vehicleType"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-text-field
                  :label="$i18n.t('Body Length')"
                  v-model="vehicleForm.length"
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="7"
                >
                  <span slot="append" color="purple"> Feet </span>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-text-field
                  :label="$i18n.t('Capacity')"
                  v-model="vehicleForm.capacity"
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="7"
                >
                  <span slot="append" color="purple"> Tonnes </span>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-select
                  :label="$i18n.t('Axel')"
                  :items="[
                    { name: 'Single Axel', value: 1 },
                    { name: 'Multi Axel', value: 2 },
                  ]"
                  v-model="vehicleForm.axel"
                  item-text="name"
                  item-value="value"
                  type="number"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  :label="$i18n.t('Fuel Type')"
                  :items="CommonUtil.getFuelTypeList()"
                  v-model="vehicleForm.fuelType"
                  item-text="name"
                  item-value="value"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row v-if="vehicleForm.marketVeh">
              {{ $i18n.t("Owner Detail") }}
            </v-row>
            <v-row v-if="vehicleForm.marketVeh">
              <v-col cols="12" sm="6" md="4" lg="4">
                <v-text-field
                  :label="$i18n.t('Owner Name')"
                  class="purple-input"
                  v-model="vehicleForm.ownerInfo.name"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field
                  :label="$i18n.t('PAN No.')"
                  class="purple-input"
                  v-model="vehicleForm.ownerInfo.pan"
                />
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2">
                <v-select
                  :label="$i18n.t('Salutation')"
                  :items="[
                    { name: 'Mr.', value: 'Mr.' },
                    { name: 'Ms.', value: 'Ms.' },
                    { name: 'Mrs.', value: 'Mrs.' },
                  ]"
                  v-model="vehicleForm.ownerInfo.contactPerson.salutation"
                  item-text="name"
                  item-value="value"
                  type="number"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field
                  :label="$i18n.t('Contact Person Name')"
                  class="purple-input"
                  v-model="vehicleForm.ownerInfo.contactPerson.name"
                />
              </v-col>
              <v-col cols="12" sm="6" md="5" lg="5">
                <v-text-field
                  :label="$i18n.t('Email')"
                  class="purple-input"
                  v-model="vehicleForm.ownerInfo.contactPerson.email"
                />
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2">
                <z-country-select
                  isd
                  hideName
                  hideFlag
                  v-model="vehicleForm.ownerInfo.contactPerson.countryCode"
                  :label="$i18n.t('Country Code')"
                />
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3">
                <v-text-field
                  :label="$i18n.t('Phone')"
                  class="purple-input"
                  type="number"
                  v-model="vehicleForm.ownerInfo.contactPerson.phone"
                />
              </v-col>
            </v-row>

            <v-row style="padding: 10px 10px">
              <v-col cols="12" sm="6" md="2" lg="2">
                <z-country-select
                  class="purple-input"
                  v-model="vehicleForm.ownerInfo.address.country"
                ></z-country-select>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2">
                <z-state-select
                  class="purple-input"
                  v-model="vehicleForm.ownerInfo.address.state"
                  :country="vehicleForm.ownerInfo.address.country"
                ></z-state-select>
              </v-col>

              <v-col cols="12" sm="6" md="2" lg="2">
                <z-city-select
                  class="purple-input"
                  v-model="vehicleForm.ownerInfo.address.city"
                  :state="vehicleForm.ownerInfo.address.state"
                  :country="vehicleForm.ownerInfo.address.country"
                ></z-city-select>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="4">
                <v-text-field
                  :label="$i18n.t('Address')"
                  v-model="vehicleForm.ownerInfo.address.addressLine"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2">
                <v-text-field
                  :label="$i18n.t('Pincode')"
                  v-model="vehicleForm.ownerInfo.address.pinCode"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-expand-transition v-if="!vehicleForm.marketVeh">
              <v-row
                style="
                  border: 1px #dbdbdb solid;
                  padding: 10px;
                  margin-top: 10px;
                "
                v-if="showAddRC"
              >
                <v-col cols="12" sm="12" md="4" lg="3">
                  <v-text-field
                    v-model="vehicleForm.rcNo"
                    :label="$i18n.t('RC No') + '*'"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><v-file-input
                    chips
                    :label="$i18n.t('RC Attachment')"
                    @change="handleRCFileUpload()"
                    v-model="rcPic"
                  ></v-file-input
                ></v-col>
              </v-row>
            </v-expand-transition>

            <v-expand-transition v-if="!vehicleForm.marketVeh">
              <v-row
                style="
                  border: 1px #dbdbdb solid;
                  padding: 10px;
                  margin-top: 10px;
                "
                v-if="showAddInsurance"
                ><v-col cols="12" sm="12" md="4" lg="3">
                  {{ vehicleForm.insurance.insuranceNo }}
                  <v-text-field
                    v-model="vehicleForm.insurance.insuranceNo"
                    :label="$i18n.t('Insurance No') + '*'"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><z-date-picker
                    v-model="vehicleForm.insurance.startDate"
                    :label="'Start Date'"
                /></v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><z-date-picker
                    v-model="vehicleForm.insurance.insuranceExpiry"
                    :label="'Expiry Date'"
                /></v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><z-name-master-select
                    :label="'Insurance Provider'"
                    v-model="vehicleForm.insurance.insuranceCompany"
                    :type="4"
                /></v-col>
                <v-col cols="12" sm="12" md="4" lg="3">
                  <v-text-field
                    :label="$i18n.t('Amount')"
                    v-model="vehicleForm.insurance.amount"
                    type="number"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    maxlength="7"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><v-file-input
                    chips
                    :label="$i18n.t('Insurance Attachment')"
                    @change="handleInsuranceFileUpload()"
                    v-model="insurancePic"
                  ></v-file-input></v-col
              ></v-row>
            </v-expand-transition>

            <v-expand-transition v-if="!vehicleForm.marketVeh">
              <v-row
                style="
                  border: 1px #dbdbdb solid;
                  padding: 10px;
                  margin-top: 10px;
                "
                v-if="showAddPUC"
                ><v-col cols="12" sm="12" md="4" lg="3">
                  <v-text-field
                    v-model="vehicleForm.puc.pucNo"
                    :label="$i18n.t('PUC No') + '*'"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><z-date-picker
                    v-model="vehicleForm.puc.issueDate"
                    :label="'Issue Date'"
                /></v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><z-date-picker
                    v-model="vehicleForm.puc.expiry"
                    :label="'Expiry Date'"
                /></v-col>
                <!-- <v-col cols="12" sm="12" md="4" lg="3"
                  ><z-name-master-select
                    :label="'PUC Issuing Authority'"
                    v-model="vehicleForm.puc.issuingAuthority"
                    :type="12"
                /></v-col> -->
                <v-col cols="12" sm="12" md="4" lg="3">
                  <v-text-field
                    :label="$i18n.t('Amount')"
                    v-model="vehicleForm.puc.amount"
                    type="number"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    maxlength="7"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><v-file-input
                    chips
                    :label="$i18n.t('PUC Attachment')"
                    @change="handlePUCFileUpload()"
                    v-model="pucPic"
                  ></v-file-input></v-col></v-row
            ></v-expand-transition>

            <v-expand-transition v-if="!vehicleForm.marketVeh">
              <v-row
                style="
                  border: 1px #dbdbdb solid;
                  padding: 10px;
                  margin-top: 10px;
                "
                v-if="showAddFitness"
                ><v-col cols="12" sm="12" md="4" lg="3">
                  <v-text-field
                    v-model="vehicleForm.fitness.certificateNo"
                    :label="$i18n.t('Fitness Certificate No') + '*'"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><z-date-picker
                    v-model="vehicleForm.fitness.issueDate"
                    :label="'Issue Date'"
                /></v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><z-date-picker
                    v-model="vehicleForm.fitness.expiry"
                    :label="'Expiry Date'"
                /></v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><z-name-master-select
                    :label="'Fitness Issuing Authority'"
                    v-model="vehicleForm.fitness.issuingAuthority"
                    :type="11"
                /></v-col>
                <v-col cols="12" sm="12" md="4" lg="3">
                  <v-text-field
                    :label="$i18n.t('Amount')"
                    v-model="vehicleForm.fitness.amount"
                    type="number"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    maxlength="7"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3"
                  ><v-file-input
                    chips
                    :label="$i18n.t('Fitness Attachment')"
                    @change="handleFitnessFileUpload()"
                    v-model="fitnessPic"
                  ></v-file-input></v-col></v-row
            ></v-expand-transition>

            <v-row>
              <!-- <v-col cols="12" sm="2" md="2" lg="2">
                <v-checkbox
                  v-if="!vehicleForm.forAdhoc"
                  v-model="vehicleForm.saveToDB"
                  :label="$i18n.t('Save to Master')"
                />
              </v-col> -->
              <!-- <v-row v-if="vehicleForm.supplier_id"> -->
              <v-col cols="12" sm="10" md="10" lg="10">
                <v-btn
                  color="cyan"
                  outlined
                  small
                  @click="showAddRC = true"
                  v-if="!showAddRC && !vehicleForm.marketVeh"
                  style="margin-right: 20px"
                >
                  <v-icon>mdi-plus</v-icon> Add RC
                </v-btn>
                <v-btn
                  color="orange"
                  outlined
                  small
                  @click="showAddInsurance = true"
                  v-if="!showAddInsurance && !vehicleForm.marketVeh"
                  style="margin-right: 20px"
                >
                  <v-icon>mdi-plus</v-icon> Add Insurance
                </v-btn>
                <v-btn
                  color="blue"
                  outlined
                  small
                  @click="showAddPUC = true"
                  v-if="!showAddPUC && !vehicleForm.marketVeh"
                  style="margin-right: 20px"
                >
                  <v-icon>mdi-plus</v-icon> Add PUC
                </v-btn>
                <v-btn
                  color="green"
                  outlined
                  small
                  @click="showAddFitness = true"
                  v-if="!showAddFitness && !vehicleForm.marketVeh"
                  style="margin-right: 20px"
                >
                  <v-icon>mdi-plus</v-icon> Add Fitness
                </v-btn>
              </v-col>
              <!-- </v-row> -->
              <v-col cols="12" sm="2" md="2" lg="2" class="text-right">
                <v-btn
                  color="success"
                  class="mr-0"
                  @click="saveVehicle()"
                  :loading="loading"
                >
                  <h3>
                    {{
                      vehicleForm.marketVeh
                        ? $i18n.t("Assign Vehicle")
                        : $i18n.t("Add Vehicle")
                    }}
                  </h3>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { doPostForm, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { Vue, Component, Watch } from "vue-property-decorator";
import { CommonUtil } from "@/js/commonUtil";

@Component({
  props: {
    label: {
      default: "Create Adhoc Vehicle",
    },
    trip_id: {
      default: null,
    },
    bodyType: {
      default: null,
    },
    truckType: {
      default: null,
    },
    owner_id: {
      default: null,
    },
    forDriver: {
      default: false,
    },
    vehicleCreateDialog: {
      default: null,
    },
  },
})
export default class VehicleCreateAdhoc extends Vue {
  vehicleFormPOSO = {
    forAdhoc: null,
    supplier_id: null,
    regNo: null,
    vehicleType: null,
    bodyType: this.bodyType,
    truckType: this.truckType,
    truckTypeStr: null,
    country: null,
    fuelType: "Diesel",
    axel: 1,
    length: null,
    capacity: null,
    saveToDB: true,
    supplierAddress: {},
    supplierContact: {},
    ownerInfo: {
      name: null,
      pan: null,
      contactPerson: {
        salutation: null,
        name: null,
        email: null,
        countryCode: 91,
        phone: null,
      },
      address: {
        addressLine: null,
        city: null,
        state: null,
        country: "India",
        pinCode: null,
      },
    },
    rcNo: null,
    insurance: {
      insuranceNo: null,
      startDate: null,
      insuranceCompany: null,
      insuranceExpiry: null,
      amount: null,
    },
    puc: {
      pucNo: null,
      issueDate: null,
      issuingAuthority: null,
      expiry: null,
      amount: null,
    },
    fitness: {
      certificateNo: null,
      issueDate: null,
      issuingAuthority: null,
      expiry: null,
      amount: null,
    },
  };
  vehicleForm = this.vehicleFormPOSO;
  CommonUtil = CommonUtil;
  vehicleCreateDialog_re = false;

  showAddRC = false;
  showAddInsurance = false;
  showAddPUC = false;
  showAddFitness = false;

  get loading() {
    return common.loading;
  }

  setTruckTypeName(name) {
    if (this.vehicleForm) {
      this.vehicleForm.truckTypeStr = name;
    }
  }

  setAdhocVehicle(data) {
    this.$emit("setAdhocVehicle", data);
    this.$emit("select", data);
    this.closeVehicleCreateDialog();
    // this.vehicleCreateDialog = null;
  }

  closeVehicleCreateDialog() {
    this.$emit("closeVehicleCreateDialog");
  }

  rcPic = null;
  handleRCFileUpload(files) {
    if (files) {
      this.rcPic = files[0];
    }
  }

  insurancePic = null;
  handleInsuranceFileUpload(files) {
    if (files) {
      this.insurancePic = files[0];
    }
  }

  pucPic = null;
  handlePUCFileUpload(files) {
    if (files) {
      this.pucPic = files[0];
    }
  }

  fitnessPic = null;
  handleFitnessFileUpload(files) {
    if (files) {
      this.fitnessPic = files[0];
    }
  }

  @Watch("vehicleCreateDialog")
  onVehicleCreateDialogChange(val) {
    this.vehicleCreateDialog_re = val;
    if (!val) this.closeVehicleCreateDialog();
  }

  @Watch("owner_id")
  onVehicleOwnerChange(val) {
    this.vehicleForm.supplier_id = val;
  }

  //   async save() {
  //     try {
  //       common.setLoading(true);
  //       const response = await doPost(
  //         `/api/trip/${this.trip_id}/makeVehicleDriver?forDriver=${this.forDriver}`,
  //         this.vehicleForm
  //       );
  //       common.setLoading(false);
  //       common.showMessage(`Vehicle Added Successfully`);
  //       if (!this.forDriver) this.setAdhocVehicle(response.vehicle);
  //       else this.setAdhocDriver(response.driver);
  //       this.vehicleForm = this.vehicleFormPOSO;
  //     } catch (e) {
  //       common.setError(e.message);
  //       common.setLoading(false);
  //     }
  //   }

  async saveVehicle() {
    try {
      if (this.vehicleForm.marketVeh) {
        if (!this.vehicleForm.regNo) {
          common.setError("Please provide Registration No.");
          return false;
        }
        if (!this.vehicleForm.bodyType) {
          common.setError("Please provide body type.");
          return false;
        }
        if (!this.vehicleForm.truckType) {
          common.setError("Please provide truck type.");
          return false;
        }
        this.setAdhocVehicle(this.vehicleForm);
      } else {
        common.setLoading(true);
        const formData = new FormData();
        const vehicleData = JSON.stringify(this.vehicleForm);
        formData.set("data", vehicleData);
        if (this.rcPic) {
          formData.append("rcPic", this.rcPic);
        }
        if (this.insurancePic) {
          formData.append("insurancePic", this.insurancePic);
        }
        if (this.pucPic) {
          formData.append("pucPic", this.pucPic);
        }
        if (this.fitnessPic) {
          formData.append("fitnessPic", this.fitnessPic);
        }
        const vehicle = await doPostForm(
          "/api/vehicle/new/form?trip_id=" + this.trip_id,
          formData
        );
        common.setLoading(false);
        common.showMessage(`Vehicle Added Successfully`);
        this.setAdhocVehicle(vehicle);
        this.vehicleForm = this.vehicleFormPOSO;
        common.setLoading(false);
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
